module.exports = __webpack_public_path__ + "static/media/mobile-hamburger-icon.a78e9bcb.svg";